
import React, { useState } from 'react';
import { Plus, Upload, X, CheckCircle, Trash, Edit, FilePlus, MapPinned, Loader2, HelpCircleIcon } from "lucide-react";

// import axiosInstance from './axiosInstance'; // Make sure this is correctly configured
import { useDispatch, useSelector } from 'react-redux';
import  { fetchtodo } from '../FeatureRedux/CompanyReducer/TESTREDUCER/todoreducer'
// import deletetodo from '../FeatureRedux/CompanyReducer/TESTREDUCER/deletetodo'
import { deletetodo } from '../FeatureRedux/CompanyReducer/TESTREDUCER/deletetodo';
const Setting = () => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.fetchtodo); // ✅ Correct

  console.log('this is', state);

  if(state.loading){
    return <h1 className='text-white'>loading...</h1>;
  }
  const get = () => {
    // You can also dispatch an action here if needed
    // dispatch(fetchtodo())
    dispatch(fetchtodo())
  };

  const del = ()=>{
    
    dispatch(deletetodo())
  }

  const reset = () => {
    window.location.reload();
  };

  return (
    <div className="p-4 min-h-screen text-white">
      <button
        className="bg-blue-600 px-4 py-2 rounded hover:bg-blue-700 transition"
        onClick={get}>
        Fetch Projects
      </button>
      <br />
      <button
        className="bg-blue-600 px-4 py-2 rounded hover:bg-blue-700 transition mt-2"
        onClick={reset}
      >
        Reset
      </button>

      <div className="mt-6 space-y-4">
        {Array.isArray(state.data) &&
          state.data.slice(0, 5).map((item, i) => (
            <div key={i} className="bg-gray-800 p-2 rounded flex items-center justify-between">
            <p>{item.title}</p>
            <Trash onClick={del} className="h-5 w-5 text-red-500 cursor-pointer hover:text-red-700" />
          </div>
          ))}
      </div>
    </div>
  );
};


export default Setting;
// import React, { useState } from 'react';
// import { Plus, Upload, X, CheckCircle, Trash, Edit, FilePlus, MapPinned, Loader2 } from "lucide-react";

// // import axiosInstance from './axiosInstance'; // Make sure this is correctly configured
// import { useDispatch, useSelector } from 'react-redux';
// import  { fetchtodo } from '../FeatureRedux/CompanyReducer/TESTREDUCER/todoreducer'
// // import deletetodo from '../FeatureRedux/CompanyReducer/TESTREDUCER/deletetodo'
// import { deletetodo } from '../FeatureRedux/CompanyReducer/TESTREDUCER/deletetodo';
// const Setting = () => {
//   const dispatch = useDispatch();
//   const state = useSelector((state) => state.fetchtodo); // ✅ Correct

//   console.log('this is', state);

//   if(state.loading){
//     return <h1 className='text-white'>loading...</h1>;
//   }
//   const get = () => {
//     // You can also dispatch an action here if needed
//     // dispatch(fetchtodo())
//     dispatch(fetchtodo())
//   };

//   const del = ()=>{
//     dispatch(deletetodo())
//   }

//   const reset = () => {
//     window.location.reload();
//   };

//   return (
//     <div className="p-4 min-h-screen text-white">
//       <button
//         className="bg-blue-600 px-4 py-2 rounded hover:bg-blue-700 transition"
//         onClick={get}
//       >
//         Fetch Projects
//       </button>
//       <br />
//       <button
//         className="bg-blue-600 px-4 py-2 rounded hover:bg-blue-700 transition mt-2"
//         onClick={reset}
//       >
//         Reset
//       </button>

//       <div className="mt-6 space-y-4">
//         {Array.isArray(state.data) &&
//           state.data.slice(0, 5).map((item, i) => (
//             <div key={i} className="bg-gray-800 p-2 rounded flex items-center justify-between">
//             <p>{item.title}</p>
//             <Trash onClick={del} className="h-5 w-5 text-red-500 cursor-pointer hover:text-red-700" />
//           </div>
//           ))}
//       </div>
//     </div>
//   );
// };


// export default Setting;


// import React, { useState,useEffect } from 'react'


// const Setting = () => {  

//   const [islogged, setIslogged] = useState(false);

//   const handlelog = () =>{
//     if(islogged === true){
//       setIslogged(false)
//     }else{
//       setIslogged(true)
//     }
//   }

//   useEffect(()=>{

//   },[])


//   return (
//     <>
//       <div className='bg-white flex justify-center'>
//       <div className='h-96'>
//         <button onClick={handlelog} className='bg-black text-white text-center'>Open Modal</button>
//       </div>

//       {islogged ? ( <div style={{width:'100px',height:'100px', backgroundColor:'green',visibility:islogged ? 'visible' : 'hidden'}}><p>open modal</p></div> ): null }

//       </div>
//     </>
//   );
// };

// export default Setting;

// import React, { useState } from 'react';

// const ModalExample = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const handleToggleModal = () => {
//     if(isModalOpen === true){
//       setIsModalOpen(false)
//     }else{
//       setIsModalOpen(true)
//     }
//   };

//   return (
//     <div style={{ textAlign: 'center', marginTop: '50px', backgroundColor:'blue', color:'white' }}>
//       <button onClick={handleToggleModal}>
//         {isModalOpen ? 'Close Modal' : 'Open Modal'}
//       </button>

//       {isModalOpen && (
//         <div style={{
//           width: '100px',
//           height: '100px',
//           backgroundColor: 'green',
//           margin: '20px auto'
//         }}>
//           Modal is open
//         </div>
//       )}



//     </div>
//   );
// };

// export default ModalExample;




// import React, { useState } from 'react';



// const ModalExample = () => {
//   const [isModalOpen , setisModalOpen] = useState(false)

//   const handleToggleModal =  () =>{
//     if(isModalOpen === true){
//       setisModalOpen(false)
//     }else{
//       setisModalOpen(true)
//     }
//   }

//   // BASIC toggle logic


//   return (
//     <div>

//       <button
//         onClick={handleToggleModal}
//         style={{
//           margin: '100px auto',
//           display: 'block',
//           padding: '10px 20px',
//           fontSize: '16px',
//           backgroundColor: 'black',
//           color: 'white',
//           border: 'none',
//           borderRadius: '5px',
//           cursor: 'pointer',
//         }}
//       >
//         {isModalOpen ? "close " : "open"}
//       </button>


//       {isModalOpen && (
//         <div
//           style={{
//             position: 'fixed',
//             top: '50%',
//             left: '50%',
//             transform: 'translate(-50%, -50%)',
//             width: '300px',
//             height: '200px',
//             backgroundColor: 'white',
//             boxShadow: '0 0 10px rgba(0,0,0,0.3)',
//             borderRadius: '10px',
//             textAlign: 'center',
//             paddingTop: '60px',
//             zIndex: 1000,
//           }}
//         >
//           <p style={{ fontSize: '18px' }}>This is a Modal</p>
//         </div>
//       )}


//     </div>
//   );
// };

// export default ModalExample;


// import React, { useState } from 'react'

// function setting() {

//   const [name , setname] = useState('')
//   const [age , setage] = useState('')
//   const [city , setcity] = useState('')
//   const handlesubmit = (e) =>{
//       e.preventDefault()
//   }
//   return (
   
//   )
// }

// export default setting;


// import React, { useState } from 'react';

// function ComponentForm() {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     city: '',
//     components: {
//       nearestLocation: false,
//       nearestInfrastructure: false,
//       bankingPartner: false,
//       jobImpact: false,
//       populationGraph: false,
//       futureGraph: false,
//     }
//   });

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleCheckboxChange = (e) => {
//     const { name, checked } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       components: {
//         ...prev.components,
//         [name]: checked
//       }
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log('Form Data:', JSON.stringify( formData));
//     alert('Form submitted! Check console for data.');
//   };

//   return (
//     <form onSubmit={handleSubmit} className="max-w-xl mx-auto mt-10 p-6 bg-gray-900 text-white rounded-lg border border-gray-700 space-y-4">
//       <h2 className="text-2xl font-bold mb-4">Project Details Form</h2>

//       <div>
//         <label className="block mb-1">Name</label>
//         <input
//           type="text"
//           name="name"
//           value={formData.name}
//           onChange={handleInputChange}
//           className="w-full p-2 rounded bg-gray-800 border border-gray-600"
//           required
//         />
//       </div>

//       <div>
//         <label className="block mb-1">Email</label>
//         <input
//           type="email"
//           name="email"
//           value={formData.email}
//           onChange={handleInputChange}
//           className="w-full p-2 rounded bg-gray-800 border border-gray-600"
//           required
//         />
//       </div>

//       <div>
//         <label className="block mb-1">City</label>
//         <input
//           type="text"
//           name="city"
//           value={formData.city}
//           onChange={handleInputChange}
//           className="w-full p-2 rounded bg-gray-800 border border-gray-600"
//         />
//       </div>

//       <div>
//         <label className="block font-semibold mb-2">Select Components to Include:</label>
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
//           <label><input type="checkbox" name="nearestLocation" onChange={handleCheckboxChange} /> Transportation Access</label>
//           <label><input type="checkbox" name="nearestInfrastructure" onChange={handleCheckboxChange} /> Nearest Infrastructure</label>
//           <label><input type="checkbox" name="bankingPartner" onChange={handleCheckboxChange} /> Banking Partners</label>
//           <label><input type="checkbox" name="jobImpact" onChange={handleCheckboxChange} /> Job Impact</label>
//           <label><input type="checkbox" name="populationGraph" onChange={handleCheckboxChange} /> Population Trends</label>
//           <label><input type="checkbox" name="futureGraph" onChange={handleCheckboxChange} /> Land Price Prediction</label>
//         </div>
//       </div>

//       <button type="submit" className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded">
//         Submit
//       </button>
//     </form>
//   );
// }

// export default ComponentForm;


